import React from 'react';
import { Typography } from '@material-ui/core';
import { Field } from 'react-final-form';
import Input from '@common/Input/Input';

import DropDown from '@components/Auth/Common/DropDown';
import PropTypes from 'prop-types';
import cx from 'classnames';

import useStyles from './styles';

const DueTimeField = ({
  baseName,
  disabled = false,
  label = 'Due date',
  className,
}) => {
  const classes = useStyles();

  return (
    <div className={cx(classes.dueTime, className)}>
      <Typography className={classes.inputLabel}>{`${label} *`}</Typography>

      <div className={classes.timeInputWrapper}>
        <span className={classes.label}>Current Time + </span>
        <Field
          id={baseName.timeValue}
          name={baseName.timeValue}
          styleType="main"
          inputView="text"
          component={Input}
          classNameWrapper={classes.timeInput}
          fullWidth
          disabled={disabled}
        />
        <Field
          id={baseName.timeKind}
          name={baseName.timeKind}
          size="small"
          component={DropDown}
          className={classes.timeInput}
          options={[
            { label: 'hours', value: 0 },
            { label: 'days', value: 1 },
          ]}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

DueTimeField.propTypes = {
  baseName: PropTypes.shape({
    timeValue: PropTypes.string,
    timeKind: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};
export default DueTimeField;
